<template>
  <div class="module-detail-container">
    <!-- 主内容区 -->
    <div class="module-content">
      <!-- 1. 模块专属图片 -->
      <div class="module-specific-image">
        <img :src="currentModule.url" :alt="currentModule.title" />
      </div>
      <div class="CarbonFootprint">
        <div class="cardBox" v-for="(item, index) in CarbonFootprint">
          <div class="CarbonFootprint_top">
            <img
              :class="'CarbonFootprint_top_img' + index"
              :src="item.img"
              alt=""
            />
          </div>
          <div class="CarbonFootprint_btn">
            <div class="CarbonFootprint_btn_title">{{ item.title }}</div>
            <div class="CarbonFootprint_btn_content">{{ item.content }}</div>
          </div>
        </div>
      </div>
      <!-- 2. 公用空状态图片 -->
      <!-- <div class="empty-state-image">
        <img src="@/assets/recycling/index/detail-empty.png" alt="空状态" />
      </div> -->

      <!-- 3. 开发中提示 -->
      <!-- <div class="development-notice">
        <p>正在开发中...</p>
      </div> -->
    </div>
    <bottom-url />
  </div>
</template>

<script>
import bottomUrl from '@/components/bottomUrl/bottomUrl.vue';
import { scrollTop } from '@/util/scrollTop';

export default {
  components: {
    bottomUrl,
  },
  data() {
    return {
      currentModule: {
        title: '产业链大数据',
        url: require('@/assets/recycling/index/chainBigData.svg'),
      },
      CarbonFootprint: [
        {
          img: require('@/assets/recycling/index/data-collection.svg'),
          title: '全量数据采集',
          content:
            '消除信息不对称、数据孤岛、沟通不畅等问题，获得全面的产业链数据。打破信息壁垒，使产业链上下游的各方能够实时共享信息，提升了整个产业链的透明度。',
        },
        {
          img: require('@/assets/recycling/index/data-value.svg'),
          title: '数据价值挖掘',
          content:
            '透明的产业链能够帮助企业更好地把握市场需求和供应情况，预测潜在的市场风险，减少决策的盲目性，提高决策效率。',
        },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
/* 基础样式 */
.module-detail-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.module-detail-container {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - 90px);
  overflow-y: auto;
  position: relative;
}

.module-content {
  width: 100%;
  padding-bottom: 32px; /* 为底部组件预留空间 */
}

/* 模块专属图片样式 */
.module-specific-image {
  width: 100%;
  margin: 0 auto 10px;
  display: block;
}
.secImg {
  width: 100%;
}
.topImg {
  object-fit: cover;
  width: 100%;
  height: 730px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.CarbonFootprint {
  width: 1400px;
  height: 360px;
  margin: 34px auto 0 auto;
  display: flex;
  justify-content: space-between;
  .cardBox {
    background: rgba(235, 238, 240, 1);
    width: 49%;
    height: inherit;
    padding: 25px;
    position: relative;
    .CarbonFootprint_top {
      min-height: 61px;
      .CarbonFootprint_top_img0 {
        width: 100px;
        height: 100px;
      }
      .CarbonFootprint_top_img1 {
        width: 100px;
        height: 100px;
      }
      //.CarbonFootprint_top_img2{
      //  width: 63px;
      //  height: 45px;
      //}
    }
    .CarbonFootprint_btn {
      .CarbonFootprint_btn_title {
        font-size: 20px;
        font-weight: 500;
        line-height: 28.96px;
        color: rgba(0, 0, 0, 1);
        margin: 15px 0;
      }
      .CarbonFootprint_btn_content {
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 23.17px;
        color: rgba(0, 0, 0, 0.6);
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .module-content {
    padding: 1.5rem 1rem 200px;
  }
}

@media screen and (max-width: 768px) {
  .module-detail-container {
    height: auto;
  }
  .module-content {
    height: auto;
    padding: 0 16px;
    background-size: 90% auto; /* 移动端适当缩小 */
  
    .CarbonFootprint {
      flex-direction: column;
      margin: 8px 0 20px;
      width: 100%;
      height: auto;
      .cardBox {
        width: 100%;
        height: auto;
        margin: 8px 0;
        .CarbonFootprint_top {
            width: 70px;
            margin-top: 10px;
            .CarbonFootprint_top_img0,.CarbonFootprint_top_img1 {
              width: 50px;
              height: auto;
              margin: 0 10px;
            }
        }
        .CarbonFootprint_btn{
          padding: 8px;
          .CarbonFootprint_btn_title {
            font-size: 14px;
            line-height: normal;
          }
          .CarbonFootprint_btn_content {
            font-size: 12px;
            line-height: normal;
            margin: 10px 0;
          }
        }
        .views {
          position: relative;
          bottom: 0;
          left: 0;
          margin: 10px;
          .views_box {
            height: 35px;
            justify-content: center;
            border-radius: 5px;
            span {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .module-content {
    background-size: 95% auto; /* 小屏幕进一步调整 */
  }
}
</style>
